/**
 * @title COSTCO.wallet.js: Feature level module
 * @description The module used for the 'wallet interactions' - masterpass and visa checkout
 * feature exists on  'CreditCardModular_UI_addEditMode.jspf
 * @dependency none
 */
define(['checkout_helper'], function(helper) {
  let wallet = {
	ccSectionShown : false,
	analyticsFlagForCVVShowTriggered: false, 
    init: function() {
      this.initButtonAda();
			this.initData(wallet_init_data);
			if (wallet_init_data.checkoutWalletType == 'VISA_CHECKOUT') {
				this.visa.onVisaCheckoutReady();
			}
			
			//wallet.init() is called by vendor so adding this to notify other
			//js modules when wallet has been initialized. (need for ordersummary.js)
			if (typeof COSTCO.Global != 'undefined') {
				COSTCO.Global.notify('WalletInitialized');
			}
			else {
				document.addEventListener('CostcoGlobalLoaded', function() {COSTCO.Global.notify('WalletInitialized');}, false);
			}
			if($("input[name='autoRenewCardType']").val() === "CO_BRANDED" ){	
				COSTCO.Checkout.showPaymentEditSection($("input[name='autoRenewCardBrand']").val());	
			}
			else if($('#ach-block-form').length && $('#ach-block-form').find('input[id=ach_account_holder]').val().length > 0) {
				COSTCO.wallet.showACHSection();
			}
			else {
				if(COSTCO.Checkout.displayAllPayments() && COSTCO.Checkout.usedPayment().length > 0){
					 COSTCO.wallet.showPaymentSectionInReview();
					return;
				} else if(typeof errorVal != 'undefined' && errorVal == 'ERR_COUNTRY_NOTVALID'){
					$('#radio-clickpay-ada-handler').click();
					COSTCO.util.announceSRMessage(messages.ERR_COUNTRY_NOTVALID);
					return;
				}
				COSTCO.wallet.showCCSection();
			}
    },
    initData: function(data) {
    
      COSTCO.wallet.walletCheckout = data.walletCheckout;
      COSTCO.wallet.checkoutReviewURL = data.checkoutReviewURL;
      COSTCO.wallet.walletModuleEnabled = data.walletModuleEnabled;

      if (data.checkoutWalletType == COSTCO.wallet.providers.MASTERPASS) {
        COSTCO.wallet.walletProvider = COSTCO.wallet.providers.MASTERPASS;
        COSTCO.wallet.currencyCode = data.currencyCode;
        COSTCO.wallet.amount = data.amount;

        let form = COSTCO.CreditCard.forms.creditCardForm();
        let callbackUrlQueryString = 'selfAddressId=' + $(form).find('input[name=selfAddressId]').val() +
          '&orderId=' + $(form).find('input[name=orderId]').val() +
          '&URL=' + $(form).find('input[name=URL]').val() +
          '&curr_date=' + $(form).find('input[name=curr_date]').val() +
          '&curr_month=' + $(form).find('input[name=curr_month]').val() +
          '&curr_year=' + $(form).find('input[name=curr_year]').val() +
          '&orderItemsCount=' + $(form).find('input[name=orderItemsCount]').val() +
          '&checkCCValue=' + $(form).find('input[name=checkCCValue]').val() +
          '&orderItemsCount=' + $(form).find('input[name=orderItemsCount]').val() +
          '&authToken=' + $(form).find('input[name=authToken]').val() +
          '&piAmount=' + $(form).find('input[name=piAmount]').val() +
          '&piId=' + $(form).find('input[name=piId]').val() +
          '&tokenSessionId=' + modularTokenSessionId +
          '&sessionId=' + modularTokenSessionId;

        COSTCO.wallet.mastercard.callbackUrl = location.protocol + '//' +
          location.hostname + (location.port ? ':' + location.port : '') +
          '/WalletCheckoutCallbackCmd?' + callbackUrlQueryString;
        
        COSTCO.wallet.showMasterpassSection();
      } else if (data.checkoutWalletType == COSTCO.wallet.providers.VISA) {
        COSTCO.wallet.walletProvider = COSTCO.wallet.providers.VISA;
        COSTCO.wallet.apiKey = data.apiKey;
        COSTCO.wallet.showVisaSection();
      } else if (data.defaultCheckoutType == COSTCO.wallet.providers.CLICKPAY) {
    	  COSTCO.wallet.walletProvider = COSTCO.wallet.providers.CLICKPAY;
    	  COSTCO.wallet.apiVersion = data.apiVersion;
    	  COSTCO.wallet.amount = data.amount;
  		  COSTCO.wallet.currencyCode = data.currencyCode;
  		  COSTCO.wallet.showClickPaySection();
      } else if (data.defaultCheckoutType == COSTCO.wallet.providers.DEFAULT) {
    	  COSTCO.wallet.showCCSection();
      }
    },

    sessionId: null,
    walletProvider: null,
    amount: null,
    currentTotal: null,
    currencyCode: null,
    callid: null,
    apiKey: null,
    apiVersion: null,
    merchantId: null,
    ajaxCall: false,
    languagePref: null,
    countryCode : 'CAN',

    providers: {
      MASTERPASS: 'MASTERPASS_ONLINE',
      VISA: 'VISA_CHECKOUT',
      DEFAULT: 'CREDIT_CARD',
      CLICKPAY: 'SECURE_REMOTE_COMMERCE',
    },

    WALLET_ERROR_PLACEHOLDER: '#wallet-error-container',

    walletCheckout: 'false',
    checkoutReviewURL: null,
    walletModuleEnabled: 'false',

    services: {

      url: {
        OPEN_WALLET: 'AjaxOpenEnterpriseWalletRest',
        UPDATE_SESSION: 'AjaxUpdateSessionEnterprisePayment',
      },

      ajaxOpenWallet: function() {
        COSTCO.wallet.hideErrorMessage();
		 if(COSTCO.wallet.currencyCode == null || !COSTCO.wallet.currencyCode){
        	COSTCO.wallet.init();
        }

        let requestData = {
          sessionId: modularTokenSessionId,
          responseType: COSTCO.wallet.responseType,
          walletProvider: COSTCO.wallet.walletProvider,
          amount: COSTCO.wallet.amount,
          currencyCode: COSTCO.wallet.currencyCode,
          originUrl: window.location.href.split('?')[0],
        };

        let options = {
          url: COSTCO.wallet.services.url.OPEN_WALLET,
          method: 'POST',
          dataType: 'json',
          data: requestData,
          done: function(data, textStatus, jqXHR, options) {
            if (data.status == 'error') {
              COSTCO.wallet.handleErrors();
              if (data.walletProvider == COSTCO.wallet.providers.MASTERPASS) {
                COSTCO.wallet.showErrorMessage(messages.ERROR_SYSTEM_MASTERPASS);
              } else if (data.walletProvider == COSTCO.wallet.providers.VISA) {
                COSTCO.wallet.showErrorMessage(messages.ERROR_SYSTEM_VISA_CHECKOUT);
              }
            } else { // data.status == 'success'
            	if(typeof data.newSessionId !== 'undefined'){
              	  modularTokenSessionId = data.newSessionId;
                }else{
              	  modularTokenSessionId = data.sessionId[0];
                }
              COSTCO.wallet.mastercard.launchMasterPassReady(JSON.parse(data.data));
            }
          },
        };

        COSTCO.util.ajax(options);
      },

      ajaxUpdateSession: function(inputData) {
        helper.show_busy_indicator();

        let visa_messages = {
          ADDRESS: messages.ERROR_BILLING_ADDRESS_VISA_CHECKOUT,
          SYSTEM: messages.ERROR_SYSTEM_VISA_CHECKOUT,
          CARD: messages.ERROR_CARD_VISA_CHECKOUT,
        };

        let masterpass_messages = {
          ADDRESS: messages.ERROR_BILLING_ADDRESS_MASTERPASS,
          SYSTEM: messages.ERROR_SYSTEM_MASTERPASS,
          CARD: messages.ERROR_CARD_MASTERPASS,
        };
        
        let clickpay_messages = {
	        SYSTEM: messages.ERROR_SYSTEM_CLICKPAY,
	      };

        let options = {
          url: COSTCO.wallet.services.url.UPDATE_SESSION,
          method: 'POST',
          dataType: 'json',
          data: inputData,
          always: function() {
            helper.remove_busy_indicator();
          },
          done: function(data, textStatus, jqXHR, options) {
            let wallet_message;
            if (data.walletProvider == COSTCO.wallet.providers.MASTERPASS) {
              wallet_message = masterpass_messages;
            } else if (data.walletProvider == COSTCO.wallet.providers.VISA) {
              wallet_message = visa_messages;
            } else if (data.walletProvider == COSTCO.wallet.providers.CLICKPAY) {
              wallet_message = clickpay_messages;
            }

            if (data.status == 'error') {
              COSTCO.wallet.handleErrors();
              if (data && 'ERR_ZIPCODE_NOTVALID' == data.errorMessage) {
                COSTCO.wallet.showErrorMessage(wallet_message.ADDRESS);
              } else {
                COSTCO.wallet.showErrorMessage(wallet_message.SYSTEM);
              }
            } else {
              let validCardForCostco = true;
              if (data.data && JSON.parse(data.data).sourceOfFunds &&
                JSON.parse(data.data).sourceOfFunds.provided &&
                JSON.parse(data.data).sourceOfFunds.provided.card) {
                let cardType = COSTCO.CreditCard.getCardType(JSON
                  .parse(data.data).sourceOfFunds.provided.card.number);
                validCardForCostco = (cardType != '?');
              }
              if (validCardForCostco) {
                COSTCO.wallet.populatePaymentForm(data);
                COSTCO.wallet.disableUseExistingWallet();
                
                if (typeof COSTCO.MembershipHelper !== 'undefined' && COSTCO.MembershipHelper.isQuickMembership) {
                	let $form = COSTCO.CreditCard.forms.creditCardForm();
                	$form.attr('action', 'CostcoBillingPayment');
                	let ftcAutoRenewConsentObj = $form.find('input[name=isPurchaseMembershipAutoRenew]');
                	if(ftcAutoRenewConsentObj.length > 0)
                		$form.find('input[name=URL]').val('OrderPrepare?URL=QuickMembershipCheckoutCmd?isTandCAccepted=true%26isPurchaseMembershipAutoRenew='+ftcAutoRenewConsentObj.val());
                	else
                		$form.find('input[name=URL]').val('OrderPrepare?URL=QuickMembershipCheckoutCmd?isTandCAccepted=true');
                }
                
                COSTCO.CreditCard.submit.creditCardForm();
              } else {
                COSTCO.wallet.handleErrors();
                COSTCO.wallet.showErrorMessage(wallet_message.CARD);
              }
            }
          },
        };

        COSTCO.util.ajax(options);
      },
    },
    clickpay: {
        /* INITIALIZE and INVOKE SECURE REMOTE COMMERCE (SRCi)API */
    	launchSRCUI: function(){
  			COSTCO.wallet.hideErrorMessage();
  			if (!COSTCO.wallet.ajaxCall) {
  				COSTCO.wallet.ajaxCall = true;
  				COSTCO.wallet.amount = wallet_init_data.amount;
  	  			COSTCO.wallet.currencyCode = wallet_init_data.currencyCode;
  	  			COSTCO.wallet.apiVersion = wallet_init_data.apiVersion;
  	  			COSTCO.wallet.languagePref = wallet_init_data.clientLocale;
  	  			if (COSTCO.wallet.languagePref == 'en_US') {
	  				COSTCO.wallet.countryCode = 'USA';
	  			}
  	  			let requestData = {
  	  	  				apiOperation: 'UPDATE_SESSION',
  	  	  				sessionId: modularTokenSessionId,
  	  	  				walletProvider: COSTCO.wallet.providers.CLICKPAY,
  	  	  				amount: COSTCO.wallet.amount,
  	  	  				currencyCode: COSTCO.wallet.currencyCode,
  	  	  		};
  	  			let options = {
  	  					url: COSTCO.wallet.services.url.UPDATE_SESSION,
  	 			        method: 'POST',
  	 			        dataType: 'json',
  	 			        data: requestData,
  	 			        done: function(data, textStatus, jqXHR, options) {
  	 			        	COSTCO.wallet.ajaxCall = false;
  				            if (data.status == 'error') {
  				            	 COSTCO.wallet.handleErrors();
  				  			     COSTCO.wallet.showErrorMessage(messages.ERROR_SYSTEM_CLICKPAY);
  				            } else {
  				            	let datajson = JSON.parse(data.data);
  				            	COSTCO.wallet.merchantId = datajson.merchant;
  				            	COSTCO.wallet.clickpay.SRCiHandler();
  				            }
  				        },
  	  			};
  	  			COSTCO.util.ajax(options);
  			}
        },
        SRCiHandler : function () {
  			SRCi.configure(COSTCO.wallet.merchantId,'Costco',location.hostname,modularTokenSessionId,
 				{	
  					wsVersion: COSTCO.wallet.apiVersion,
 		        },
 		        function(response) {
 		        	if(response.result){
 		        		SRCi.launchUI(
 		        			{
 		        				orderAmount:  COSTCO.wallet.amount,
	  		  		    		orderCurrency: COSTCO.wallet.currencyCode,
	  		  		    		dpaBillingPreference: 'FULL',
	  		  		    		consumerEmailAddressRequested: true,
	  		  		    		interactionCountry: COSTCO.wallet.countryCode,
	  		  		    		interactionLocale: COSTCO.wallet.languagePref,
 		        			},
	  		  		    	COSTCO.wallet.clickpay.payloadCallback,
	  		  		    	COSTCO.wallet.clickpay.errorCallback,
	  		  		    	COSTCO.wallet.clickpay.cancelCallback
	  		  		   	);
 				    } else {
 				    	COSTCO.wallet.handleErrors();
 				    	COSTCO.wallet.showErrorMessage(messages.ERROR_SYSTEM_CLICKPAY);
 				    }
 				});
  		},
    	payloadCallback : function (correlationId, scheme) {
    		if (correlationId !== 'undefined' && correlationId.length > 0) {
    			let updateSessionOptions = {
    				apiOperation: 'UPDATE_SESSION_FROM_WALLET',
  	              	sessionId: modularTokenSessionId,
  	              	walletProvider: COSTCO.wallet.providers.CLICKPAY,
  	              	correlationId: correlationId,
  	              	scheme: scheme,
  	            };
                if(COSTCO.Checkout.setClickToPayTriggered){
    			        COSTCO.Checkout.setClickToPayTriggered();
                }
  	            COSTCO.wallet.services.ajaxUpdateSession(updateSessionOptions);
  	        } else {
  	            COSTCO.wallet.handleErrors();
  	            COSTCO.wallet.showErrorMessage(messages.ERROR_SYSTEM_CLICKPAY);
  	        }
  		},
  		errorCallback : function (error) {
  		    COSTCO.wallet.handleErrors();
  		    COSTCO.wallet.showErrorMessage(messages.ERROR_SYSTEM_CLICKPAY);
  		},
  		cancelCallback : function () {
  		    //do nothing
  		},
    },
    mastercard: {
      /**
       * INITIALIZE and INVOKE THE MASTERPASS LIGHTBOX
       */
      launchMasterPassReady: function(data) {
        MasterPass.client.checkout({
          version: 'v6',
          callbackUrl: COSTCO.wallet.mastercard.callbackUrl,
          successCallback: COSTCO.wallet.mastercard.onSuccessfulCheckout,
          cancelCallback: COSTCO.wallet.mastercard.onCancel,
          failureCallback: COSTCO.wallet.mastercard.onFailure,
          requestToken: data.wallet.masterpass.requestToken,
          merchantCheckoutId: data.wallet.masterpass.merchantCheckoutId,
          allowedCardTypes: wallet_init_data.mpEnabledCards,
          suppressShippingAddressEnable: 'true',
        });
      },
      onSuccessfulCheckout: function(data) {
        if (data.mpstatus == 'success') {
          let updateSessionOptions = {
            sessionId: modularTokenSessionId,
            walletProvider: COSTCO.wallet.walletProvider,
            checkout_resource_url: data.checkout_resource_url,
            oauth_token: data.oauth_token,
            oauth_verifier: data.oauth_verifier,
          };

          COSTCO.wallet.services.ajaxUpdateSession(updateSessionOptions);
        } else {
          COSTCO.wallet.handleErrors();
          COSTCO.wallet.showErrorMessage(messages.ERROR_SYSTEM_MASTERPASS);
        }
      },

      onCancel: function() {
        // do nothing
      },

      onFailure: function(data) {
        COSTCO.wallet.handleErrors();
        COSTCO.wallet.showErrorMessage(messages.ERROR_SYSTEM_MASTERPASS);
      },
      callbackUrl: null,
    },
    visa: {
      onVisaCheckoutReady: function() {
        V.init({
          apikey: COSTCO.wallet.apiKey,
          sessionId: modularTokenSessionId,
          paymentRequest: {
            currencyCode: COSTCO.wallet.currencyCode,
            total: COSTCO.wallet.currentTotal,
          },
          settings: {
            shipping: {
              collectShipping: 'false',
            },
            payment: {
              cardBrands: wallet_init_data.vcEnabledCards,
              acceptCanadianVisaDebit: 'false',
              billingCountries: ['US', 'CA'],
            },
          },
        });

        V.on('payment.success', function(payment) {
          $(COSTCO.CreditCard.forms.creditCardForm()).find('input[name=callid]').val(payment.callid);
          let requestData = {
            sessionId: modularTokenSessionId,
            walletProvider: COSTCO.wallet.walletProvider,
            callid: payment.callid,
          };

          COSTCO.wallet.services.ajaxUpdateSession(requestData);
        });

        V.on('payment.cancel', function(payment) {
          // do nothing
        });

        V.on('payment.error', function(payment, error) {
          COSTCO.wallet.handleErrors();
          COSTCO.wallet.showErrorMessage(messages.ERROR_SYSTEM_VISA_CHECKOUT);
        });
      },
    },
    handleErrors: function() {
      $('#wallet-block').addClass('form-control error-wallet error');
    },
    populatePaymentForm: function(data) {
      let form = COSTCO.CreditCard.forms.creditCardForm();
      let serviceResponse = JSON.parse(data.data);

      let payMethodId = null;
      if (serviceResponse.sourceOfFunds.provided.card.brand == 'VISA') {
        payMethodId = COSTCO.CreditCard.cardTypes.VISA;
      } else if (serviceResponse.sourceOfFunds.provided.card.brand == 'MASTERCARD') {
        payMethodId = COSTCO.CreditCard.cardTypes.MASTER_CARD;
      } else if (serviceResponse.sourceOfFunds.provided.card.brand == 'DISCOVER') {
        payMethodId = COSTCO.CreditCard.cardTypes.DISCOVER;
      } else if (serviceResponse.sourceOfFunds.provided.card.brand == 'JCB') {
    	payMethodId = COSTCO.CreditCard.cardTypes.JCB;  
      } else if (serviceResponse.sourceOfFunds.provided.card.brand == 'DINERS_CLUB') {
    	payMethodId = COSTCO.CreditCard.cardTypes.DINERS_CLUB;  
      }

      if (payMethodId) {
        $(form).find('input[name=payMethodId]').val(payMethodId);
      }

      $(form).find('input[name=walletProvider]').val(data.walletProvider);
      $(form).find('input[name=oauth_token]').val(data.oauth_token);
      $(form).find('input[name=oauth_verifier]').val(data.oauth_verifier);

      if (serviceResponse.wallet.visaCheckout) {
        $(form).find('input[name=cardArts]').val(serviceResponse.wallet.visaCheckout.cardArts);
      }

      $(form).find('input[name=cardNumberValueHolder]').val(serviceResponse.sourceOfFunds.provided.card.number);

      let expMonth = serviceResponse.sourceOfFunds.provided.card.expiry.month;
      if (expMonth.length == 1) {
        expMonth = '0' + expMonth;
      }
      $(form).find('input[name=expire_month]').val(expMonth);

      let expYear = serviceResponse.sourceOfFunds.provided.card.expiry.year;
      if (expYear.length == 2) {
        expYear = '20' + expYear;
      }
      $(form).find('input[name=expire_year]').val(expYear);

      $(form).find('input[name=cc_expiry_date]').val(expMonth + '/' + expYear);
      $(form).find('input[name=cc_nameoncard]').val(serviceResponse.sourceOfFunds.provided.card.nameOnCard);
      $(form).find('input[name=account]').val(serviceResponse.sourceOfFunds.provided.card.number);
      $(form).find('input[name=ccLastFour]').val(serviceResponse.sourceOfFunds.provided.card.number.slice(-4));
    },
    showErrorMessage: function(message) {
      $(COSTCO.wallet.WALLET_ERROR_PLACEHOLDER).html(message);
    },
    hideErrorMessage: function() {
      $(COSTCO.wallet.WALLET_ERROR_PLACEHOLDER).html('');
    },
    showErrorBox: function() {
      $('#wallet-block').addClass('form-control error-wallet validationError');
    },
    hideErrorBox: function() {
      $('#wallet-block').removeClass('form-control error-wallet validationError');
    },
    showVisaSection: function() {
      $('input[id=appliedPayMethod]').val('');
      $('#save_CC').prop('checked', false);
      $('#save_ACH').prop('checked', false);
      $('#radio-visa').prop('checked', true);
      COSTCO.util.showHtmlElementByFlag($('#payment-address-form'), false);
      $('[data-payment-type-element="true"]').each(function() {
    	  this.setAttribute("aria-checked", "false");
      });
      $('#radio-visa-ada-handler').attr('aria-checked', true);

      $('#radio-credit-card').prop('checked', false);
      $('#visa-payment-block').removeClass('hide');
      $('#cc-payment-block').addClass('hide');
      $('#cc-payment-address-block').addClass('hide'); 
      $('#address-container-billing').addClass('hide');
      $('#wallet-edit-link').removeClass('hide');
      $('#check-payment-block').addClass('hide');
      $('#ar-payment-block').addClass('hide');
      $('#ach-payment-block').addClass('hide');
      $('#applepay-payment-block').addClass('hide');
     COSTCO.QuickRenewAddressHelper.configureAddressesSectionBasedOnPaymentType('wallet');
    },
   
    showCheckOnDeliverySection: function() {
    	currentPaymentRadioButton = 'radio-check';
    	$('#radio-check').prop('checked', true);
    	$('input[id=appliedPayMethod]').val('');
    	$('[data-payment-type-element="true"]').each(function() {
      	  this.setAttribute("aria-checked", "false");
        });
        $('#radio-check-ada-handler').attr('aria-checked', true);

    	$('#radio-credit-card').prop('checked', false);
        $('#check-payment-block').removeClass('hide');
        $('#cc-payment-block').addClass('hide');
        $('#cc-payment-address-block').addClass('hide'); 
        $('#clickpay-payment-block').addClass('hide');
        $('#masterpass-payment-block').addClass('hide');
        $('#visa-payment-block').addClass('hide');
        $('#ach-payment-block').addClass('hide');
        $('#ar-payment-block').addClass('hide');
        $('#address-container-billing').removeClass('hide');
        $('#payment-method-cash-card').removeClass('hide');
        $('#wallet-edit-link').addClass('hide');
        $("#CheckoutPaymentForm input[name=doBillingPaymentCmd]").val('true');
        COSTCO.util.showHtmlElementByFlag($('#payment-address-form'), costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && $('#cashcard-block .card-container').length > 0);
      },
      
      
      /**
       * Adds validation methods for ACH form validation
       */
      addValidationMethods: function() {
  		$.validator.setDefaults({
  			ignore: '.ignore',
  		});
  		
  		$.validator.addMethod("achtype", function(value, element, param) {
			return this.optional(element) || value !== param;
		  }, "Value must not equal arg.");
		
		$.validator.addMethod("achNoSpChar", function(value, element, param) {
		  value = value.replace(/\s+/g,"");				
		  return this.optional(element) || /^\w+$/i.test(value);			
		  }, messages.ERR_INVALID_ACH_SPECIAL_CHARACTERS);
		
		$.validator.addMethod("achAccountNumber", function(value, element, param) {
			return this.optional(element) || /^(\d{1,13}|\*{1,13}|\x{1,13})\d{4}$/.test(value);			
		}, messages.ERR_INVALID_ACCOUNTNUM);
		
		$.validator.addMethod("achRoutingNumber", function(value, element, param) {
			return this.optional(element) || /^\d{9}$/.test(value);			
		}, messages.ERR_INVALID_ROUTINGNUM);
		
		$.validator.addMethod("achNameLen", function(value, element, param) {
		  return this.optional(element) || value.length ==0 || value.length < 29;			
		  }, messages.ERR_INVALID_ACH_NAME);
		
		$('#ach-block-form').validate();
      
      },
      /**
       * Validation rules for ACH input fields
       */
      achValidationRules: {
           ach_account_holder: {
          	required: true,
    	   		achNameLen: true,
    	   		messages: {
          	    required: messages.ERR_ACH_NAME_REQ,
          	    achNameLen: messages.ERR_INVALID_ACH_NAME
          	    }
           },
           accountType: {
      	   	required: true,
     			achtype: "-1",
     			messages: {
     				required: messages.ERR_ACH_CARDTYPE_REQ,
     				achtype: messages.ERR_ACH_CARDTYPE_REQ
     			}
           },
         ach_routing_number: {
      	   	required: true,
     			achNoSpChar: true,
     			achRoutingNumber: true,
     			messages: {
     				required: messages.ERR_ROUTINGNUM_REQ,
     				achNoSpChar: messages.ERR_INVALID_ROUTINGNUM
     			}
           },
           ach_account_number: {
          	 required: true,
          	 achAccountNumber: true,
          	 messages: {
          		required: messages.ERR_ACH_CCNUM_REQ,
          	    achNoSpChar: messages.ERR_INVALID_ACCOUNTNUM,
          	    achAccountNumber: messages.ERR_INVALID_ACCOUNTNUM
          	 }
           },
           ach_checkbox: {
          	 required: true,
          	 messages: {
          		required: messages.ACH_AGREE_PROMPT
          	 }
           },
      },  
      
      achCybersourceValidationRules: {
          ach_account_holder: {
         	required: true,
   	   		achNameLen: true,
   	   		messages: {
         	    required: messages.ERR_ACH_NAME_REQ,
         	    achNameLen: messages.ERR_INVALID_ACH_NAME
         	    }
          },
          accountType: {
     	   	required: true,
    			achtype: "-1",
    			messages: {
    				required: messages.ERR_ACH_CARDTYPE_REQ,
    				achtype: messages.ERR_ACH_CARDTYPE_REQ
    			}
          },
          ach_checkbox: {
         	 required: true,
         	 messages: {
         		required: messages.ACH_AGREE_PROMPT
         	 }
          },
     },  

		/**
		* Resets the Payment radio button back to previous value after Shop Card Modal close or cancel 
		* @return {void}
		*/
		resetPaymentRadioButton: function(buttonName){
			COSTCO.dialog.close();
			switch(currentPaymentRadioButton) {
				case "radio-check":
					COSTCO.wallet.showCheckOnDeliverySection();
					$('#radio-check').focus();
					break;
				case "radio-acct-rec":
					COSTCO.wallet.showAcctReceivableSection();
					$('#radio-ar').focus();
					break;
				case "radio-credit-card":
				default:
					COSTCO.wallet.showCCSection();
					$('#radio-credit-card').focus();
					break;
			}
			window.digitalDataEvents = window.digitalDataEvents || [];
			digitalDataEvents.push({ui:"Confirm ACH Payment Modal | " + buttonName});
		},

		/**
		* Opens 'ACH with Shop Card' dialog modal.
		* @return {void}
		*/
		openACHWithShopCardModal: function(){
			if (hasCashCard) {
				COSTCO.dialog.createExtDialogBox({
					title: messages.CHECKOUT_PAYMENT_AchShopCardDlg_Title,
					modalLabel: messages.CHECKOUT_PAYMENT_AchShopCardDlg_A11yLabel,
					body: messages.CHECKOUT_PAYMENT_AchShopCardDlg_Body,
					primary: messages.CHECKOUT_PAYMENT_AchShopCardDlg_Continue,
					secondary: messages.CHECKOUT_PAYMENT_AchShopCardDlg_Cancel,
					primary_event: function(){   // Continue
						COSTCO.dialog.close();
						$("<input>").attr({
							type: "hidden",
							name: "selectACH",
							value: "true"
						}).appendTo(".remove-cashcard-form");
						COSTCO.CC.removeCashCard($('#remove-cash-card-link'));
						COSTCO.wallet.showACHSection();
						window.digitalDataEvents = window.digitalDataEvents || [];
						digitalDataEvents.push({ui:"Confirm ACH Payment Modal | Continue"});
					},
					secondary_event: function(){   // Cancel
						COSTCO.wallet.resetPaymentRadioButton('Cancel');
					},
					close: function() {   // Close
						COSTCO.wallet.resetPaymentRadioButton('Close');
					}
				});
			} else {
				COSTCO.wallet.showACHSection();
			}
		},
      
      showACHSection: function() {
    	  currentPaymentRadioButton = 'radio-ach';
    	  $('input[id=appliedPayMethod]').val('');
          $('#radio-ach').prop('checked', true);

          $('[data-payment-type-element="true"]').each(function() {
        	  this.setAttribute("aria-checked", "false");
          });
          $('#radio-ach-ada-handler').attr('aria-checked', true);

          $('#radio-credit-card').prop('checked', false);
          $('#ach-payment-block').removeClass('hide');
          // Workaround init "agree to terms" checkbox to false!
          $('#save_as_default2').prop('checked', false);
          
          if ($('#isBDAppVar').val() == 'BD' && !COSTCO.MembershipHelper.isQuickMembership) {
	    		  $('#save_ACH').prop('checked', true);
          }
          $('#cc-payment-block').addClass('hide');
          $('#cc-payment-address-block').addClass('hide'); 
          $('#clickpay-payment-block').addClass('hide');
          $('#masterpass-payment-block').addClass('hide');
          $('#visa-payment-block').addClass('hide');
          $('#ar-payment-block').addClass('hide');
          $('#check-payment-block').addClass('hide');
          $('#address-container-billing').removeClass('hide');
          $('#wallet-edit-link').addClass('hide');
          if (($('#ach-block-form').is(':visible')) || ($('#credit-card-info-container').is(':visible') && ($('#ordPayInsVal') && $('#ordPayInsVal').val() == "ACH"))) {
              $('#payment-method-cash-card').addClass('hide');
          }
          if($('#isBDAppVar').val() == 'BD'){
        	  wallet.creditCardValidationOnOff(false);
        	  //wallet.ARValidationOnOff(false); //STRY0144990 
        	  if($("#ach-block-form") && $("#ach-block-form").length > 0){
	        	  wallet.addValidationMethods();
	        	  if(COSTCO.CreditCard.isCybersourceEnabled()){
	        		  wallet.addRules(wallet.achCybersourceValidationRules);
	        	  } else {
	        		  wallet.addRules(wallet.achValidationRules);
	        	  }
        	  }

        	  if($("#CheckoutPaymentForm") && $("#CheckoutPaymentForm").length > 0){
        		  $('#CheckoutPaymentForm').validate().resetForm();
        	  }
          }
          $("#CheckoutPaymentForm input[name=doBillingPaymentCmd]").val('true');
          COSTCO.util.showHtmlElementByFlag($('#payment-address-form'), costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && $('#cashcard-block .card-container').length > 0);
        },

        /**
         * Helper function to add rules to form input fields
         */
        addRules: function(rulesObj) {
            for (var item in rulesObj) {
            	if (item == 'accountType') {
            		$('select[name='+ item + ']').rules('add',rulesObj[item]);  
            	} else {
            		$('input[name='+ item + ']').rules('add',rulesObj[item]);  
            	}
            	
            } 
        },
        
        showAcctReceivableSection: function() {
            currentPaymentRadioButton = 'radio-acct-rec';
            $('#radio-ar').prop('checked', true);
            $('input[id=appliedPayMethod]').val('');
            $('[data-payment-type-element="true"]').each(function() {
          	  this.setAttribute("aria-checked", "false");
            });
            $('#radio-ar-ada-handler').attr('aria-checked', true);

            $('#radio-credit-card').prop('checked', false);
            $('#ar-payment-block').removeClass('hide');
            $('#cc-payment-block').addClass('hide');
            $('#cc-payment-address-block').addClass('hide');
            $('#clickpay-payment-block').addClass('hide');
            $('#masterpass-payment-block').addClass('hide');
            $('#visa-payment-block').addClass('hide');
            $('#ach-payment-block').addClass('hide');
            $('#check-payment-block').addClass('hide');
            $('#address-container-billing').removeClass('hide');
            $('#payment-method-cash-card').removeClass('hide');
            $('#wallet-edit-link').addClass('hide');
            COSTCO.util.showHtmlElementByFlag($('#payment-address-form'), costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && $('#cashcard-block .card-container').length > 0);
            if($('#isBDAppVar').val() == 'BD'){
            	wallet.creditCardValidationOnOff(false);
          	  	//wallet.ARValidationOnOff(true); //STRY0144990
          	  if($("#CheckoutPaymentForm") && $("#CheckoutPaymentForm").length > 0)$('#CheckoutPaymentForm').validate().resetForm();
            }
            $("#CheckoutPaymentForm input[name=doBillingPaymentCmd]").val('true');
          },
    showMasterpassSection: function() {
      $('input[id=appliedPayMethod]').val('');
      COSTCO.util.showHtmlElementByFlag($('#payment-address-form'), false);
      $('#save_CC').prop('checked', false);
      $('#radio-credit-card').prop('checked', false);
      $('#radio-master').prop('checked', true);
      $('#masterpass-payment-block').removeClass('hide');
      $('#cc-payment-block').addClass('hide');
      $('#cc-payment-address-block').addClass('hide'); 
      $('#address-container-billing').addClass('hide');
      $('#wallet-edit-link').removeClass('hide');
      $('#check-payment-block').addClass('hide');
      $('#ar-payment-block').addClass('hide');
      
      $('#master-pass-checkout').on('click keypress', function(e){
 		 if (e.which === 13 || e.type === 'click') {
 			 wallet.services.ajaxOpenWallet();
 	     }
 	  });

      $('[data-payment-type-element="true"]').each(function() {
    	  this.setAttribute("aria-checked", "false");
      });
      $('#radio-master-ada-handler').attr('aria-checked', true);
      $('#applepay-payment-block').addClass('hide');
    },
    showClickPaySection: function() {
    	$('input[id=appliedPayMethod]').val('');
        $('#save_CC').prop('checked', false);
        $('#save_ACH').prop('checked', false);
        $('#radio-clickpay').prop('checked', true);
        COSTCO.util.showHtmlElementByFlag($('#payment-address-form'), false);
        $('[data-payment-type-element="true"]').each(function() {
        	  this.setAttribute("aria-checked", "false");
          });
        $('#radio-clickpay-ada-handler').attr('aria-checked', true);
        $('#radio-credit-card').prop('checked', false);
        if(COSTCO.Checkout.displayAllPayments() && COSTCO.Checkout.usedPayment() === 'wallet'){
        	$('#clickpay-payment-block').addClass('hide');
        	 $('#clicktopay-block-form').removeClass('hide');
             $('#wallet-payment-address-block').removeClass('hide');
        } else {
        	$('#clickpay-payment-block').removeClass('hide');
        }
        $('#cc-payment-block').addClass('hide');
        $('#cc-payment-address-block').addClass('hide'); 
        $('#address-container-billing').addClass('hide');
        $('#wallet-edit-link').removeClass('hide');
        $('#check-payment-block').addClass('hide');
        $('#ar-payment-block').addClass('hide');
        $('#ach-payment-block').addClass('hide');
        $('#clickpay-checkout').on('click keypress', function(e){
        	if (e.which === 13 || e.type === 'click') {
   			 	wallet.clickpay.launchSRCUI();
   	     	}
   	  	});
        $('#applepay-payment-block').addClass('hide');
        $('#applepay_not_supported').addClass('hide');
        $('#place-order-button-regular').removeAttr('do-not-show');
		$('#place-order-button-regular').removeClass('hide');
		$('#place-order-button-applepay').attr('do-not-show','true');
		$('#place-order-button-applepay').addClass('hide');
        COSTCO.QuickRenewAddressHelper.configureAddressesSectionBasedOnPaymentType('wallet');
      },
      
      showUnifiedClickPaySection: function() {
    	  createUnifiedTokenSessionId();
    	  COSTCO.wallet.showClickPaySection();
        },
      
    showCCSection: function() {
      currentPaymentRadioButton = 'radio-credit-card';
      $('input[id=appliedPayMethod]').val('');
      
      $('[data-payment-type-element="true"]').each(function() {
    	  this.setAttribute("aria-checked", "false");
      });
      if(COSTCO.Checkout.displayAllPayments()){
    	  $('#clicktopay-block-form').addClass('hide');
          $('#wallet-payment-address-block').addClass('hide');
          $('#applepay_not_supported').addClass('hide');
	      $('#place-order-button-regular').removeClass('hide');
	      $('#place-order-button-applepay').addClass('hide');
	      if(COSTCO.Checkout.usedPayment() ==='creditcard'){
	    	  $('#radio-credit-card-review').prop('checked', true);
	    	  $('#radio-credit-card-review-ada-handler').attr('aria-checked', true);
	      } else {
	    	  $('#radio-credit-card').prop('checked', true);
	          $('#radio-credit-card-ada-handler').attr('aria-checked', true);
	      }
	      $('#payment-address-form').removeClass('hide');
	      $('#clickpay-payment-block').addClass('hide');
	      
      } else{
    	  $('#radio-credit-card').prop('checked', true);
          $('#radio-credit-card-ada-handler').attr('aria-checked', true);
      }
      if((!wallet.ccSectionShown || $("#cc-payment-block").hasClass("hide")) && $('#single-page-checkout #cc-payment-block').attr('do-not-show') !== 'true'){
          if(COSTCO.MembershipHelper.isQuickMembership){
        	  $('#address-block-billing').parent().show();
          } else {
        	  COSTCO.util.showHtmlElementByFlag($('#payment-address-form'), costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && true);
          }
	      wallet.ccSectionShown = true;
	      if(!COSTCO.CreditCard.initComplete){
	    	  COSTCO.CreditCard.init();
	      }
	      $("input[name=payment-radio]:radio").each(function(index){
	    	 if(this.id != 'radio-credit-card'){
	    		 $(this).prop('checked', false);
	    	 }
	      });
	      $('#cc-payment-block').removeClass('hide');
	      if((!$("#credit-card-block").hasClass("hide")) && wallet.ccSectionShown == true && !wallet.analyticsFlagForCVVShowTriggered){
		      window.digitalDataEvents = window.digitalDataEvents || [];
		      digitalDataEvents.push({ uimsg:"Checkout Flow | CVV Field Appear", checkoutEvent:"CVV Field Appear" });
		      wallet.analyticsFlagForCVVShowTriggered=true;
	      }
	      $('#cc-payment-address-block').removeClass('hide'); 
	      $('#clickpay-payment-block').addClass('hide');
	      $('#masterpass-payment-block').addClass('hide');
	      $('#visa-payment-block').addClass('hide');
	      $('#address-container-billing').removeClass('hide');
	      $('#payment-method-cash-card').removeClass('hide');
	      $('#check-payment-block').addClass('hide');
	      $('#ach-payment-block').addClass('hide');
	      $('#ar-payment-block').addClass('hide');
	      $('#wallet-edit-link').addClass('hide');
	      $('#applepay-payment-block').addClass('hide');
	      $('#applepay_not_supported').addClass('hide');
	      $('#place-order-button-regular').removeClass('hide');
	      $('#place-order-button-applepay').addClass('hide');
	      if($('#isBDAppVar').val() == 'BD'){
	    	  	//wallet.ARValidationOnOff(false); //STRY0144990 
	    		wallet.creditCardValidationOnOff(true);
	    		if($("#CheckoutPaymentForm") && $("#CheckoutPaymentForm").length > 0)$('#CheckoutPaymentForm').validate().resetForm();
	      }
	      // Remove error messages if wallet section is deselected.
	      wallet.hideErrorBox();
	      wallet.hideErrorMessage();
	      if(COSTCO.CreditCard.isCCEditAreaVisible() && $('#account_validator').val() !== '' && $('#cc_expiry_date').val() !== ''){
	    	  COSTCO.CreditCard.validate.creditCardForm();
	    	  $("label[for='cc_cvc_validator']").text(messages.CVV_REENTER);
	      }
	      else{
	    	  if (wcs.storeId == '10301') {
	    		  $('#save_CC').prop('checked', true);
	    	  }
	    	  else if (!COSTCO.MembershipHelper.isQuickMembership) {
	    		  $('#save_CC').prop('checked', true);
	    	  }
	    	  else {
	    		  $('#save_CC').prop('checked', false);
	    	  }
	      }
      }
      
    },
    
    showPaymentSectionInReview: function(){
    	$("input[name=payment-radio]:radio").each(function(index){
   		 	$(this).prop('checked', false);
	    });
		$('[data-payment-type-element="true"]').each(function() {
	   	 	this.setAttribute("aria-checked", "false");
	    });
		if(COSTCO.Checkout.usedPayment() === 'applepay'){
			COSTCO.applepay.showApplePaySection();
	    } else if(COSTCO.Checkout.usedPayment() === 'wallet'){
	    	COSTCO.wallet.showClickPaySection();
	    } else {
	    	COSTCO.wallet.showCCSection();
	    }
    },
    creditCardValidationOnOff : function(isOn){
    	
  	  var feilds = $("#credit-card-block").find("[name=account], [name=cc_cvc_validator], [name=cc_nameoncard], [name=cc_expiry_date]");
  	  (isOn && isOn == true) ? feilds.removeClass("ignore") : feilds.addClass("ignore");
    },
    ARValidationOnOff : function(isOn){
    	  var parent = $("#ar-payment-block");
    	  if($("#ar-payment-block") && $("#ar-payment-block").length > 0){
    		  jQuery.validator.addMethod("arNoSpChar", function(value, element, param) {
    			  value = value.replace(/\s+/g,"");		
    			  return this.optional(element) || /^\w+$/i.test(value);	
  		     }, "Value must not have special characters.");
    		  var arrFeilds = [
        	                   {
        	                	   feild : "poNumber", 
        	                	   rule : {
        	                	   		required: true,
        	                	   		arNoSpChar:true,
	      					        	  messages: {
	      					        	    required: messages.ERR_PONUM_REQ,
	      					        	    arNoSpChar: messages.ERR_INVALID_PONUM
	      					        	  }
        	                   		}
        	                   }
        	                   ]
        	  for(var i=0; i < arrFeilds.length; i++){
        		  var feild = parent.find("[name=" + arrFeilds[i].feild + "]");
        		  (isOn && isOn == true) ? feild.rules( "add", arrFeilds[i].rule) : feild.rules("remove");
        	  } 
    	  }
      },

    /**
     * Checks the state of the wallet visa checkout radio button selection
     * @return 1 if user has selected visa checkout radio button, otherwise returns 0
     */
    isVisacheckoutOptionSelected: function() {
      return $('input[id=radio-visa]:checked').length;
    },
    /**
     * Checks the state of the wallet masterpass radio button selection
     * @return 1 if user has selected masterpass radio button, otherwise returns 0
     */
    isMasterpassOptionSelected: function() {
      return $('input[id=radio-master]:checked').length;
    },
    /**
     * Checks the state of the wallet src clickpay radio button selection
     * @return 1 if user has selected src clickpay radio button, otherwise returns 0
     */
    isClickPayOptionSelected: function() {
      return $('input[id=radio-clickpay]:checked').length;
    },
    /**
     * Checks the state of the check on delivery radio button selection
     * @return 1 if user has selected check on delivery button, otherwise returns 0
     */
    isCheckOnDeliveryOptionSelected: function() {
      return $('input[id=radio-check]:checked').length;
    },
    disableUseExistingWallet: function() {
      $('[name=walletCheckout]').attr('value', 'false');
    },

    enableUseExistingWallet: function() {
      $('[name=walletCheckout]').attr('value', 'true');
    },

    /**
     * Checks the state of any of the wallet radios
     * @return 1 if user has selected masterpass / visa checkout radio button, otherwise returns 0
     */
    isSelected: function() {
      let selected = $('#wallet-block input[name=\'payment-radio\']:checked').val();
      let used = ($('#wallet-info-div').length > 0 && !$('#wallet-info-div').hasClass('hide'));
      // Update form state on the credit card form
      if (selected || used) {
        COSTCO.wallet.enableUseExistingWallet();
      } else {
        COSTCO.wallet.disableUseExistingWallet();
      }

      return selected;
    },
    
    isUsed: function() {
        return ($('#wallet-info-div').length > 0 && !$('#wallet-info-div').hasClass('hide'));
      },

    isComplete: function() {
      if (typeof wallet_init_data === 'undefined') {
        return false;
      } else {
        return wallet_init_data.walletCheckout;
      }
    },
    initButtonAda: function() {
      $('#cc-section, #visa-section').unbind().on('keydown', function(event) {
        if (event.which === 13 || event.which === 32) {
          this.click();
          event.stopPropagation();
          event.preventDefault();
        }
      });
    }
  }; // end wallet object

  // Expose wallet to the global scope.
  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = new Object();
  }

  window.COSTCO.wallet = wallet;

  return wallet;
});



// WEBPACK FOOTER //
// ./js/checkout/wallet.js